import { Button } from '@/components/ui/catalyst/button';
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogDescription,
  DialogTitle,
} from '@/components/ui/catalyst/dialog';
import { Z_INDEX_MODAL_BASE } from '@/components/ui/zIndex';

import { RequestTemplatePanel } from './RequestTemplatePanel';

interface RequestTemplateModalProps {
  open: boolean;
  onClose: () => void;
  providerServiceId: string;
  providerName: string;
  onSaved?: () => void;
}

export const RequestTemplateModal = ({
  open,
  onClose,
  providerServiceId,
  providerName,
  onSaved,
}: RequestTemplateModalProps) => {
  return (
    <Dialog open={open} onClose={onClose} size="2xl" zIndex={Z_INDEX_MODAL_BASE}>
      <DialogTitle>Configure Request Template</DialogTitle>
      <DialogDescription>{providerName}</DialogDescription>
      <DialogBody>
        <RequestTemplatePanel
          providerServiceId={providerServiceId}
          onSaved={() => {
            onSaved?.();
          }}
        />
      </DialogBody>
      <DialogActions>
        <Button outline onClick={onClose}>
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};
